import classNames from "classnames";
import { ACTIVITY_TYPES } from "../../../lib/constants/activity-types";
import AscGenericCard from "../AscGenericCard/AscGenericCard";
import styles from "./AscActivityTypeCard.module.scss";
import { AscActivityTypeCardProps } from "./AscActivityTypeCard.types";

export default function AscActivityTypeCard({
  className,
  type,
  title,
  description,
}: AscActivityTypeCardProps) {
  return (
    <AscGenericCard
      data-testid="asc-activity-type-card"
      className={classNames(styles.ground, className)}
      title={null}
      coverImageUrl={null}
      contentClassName={styles.content}
      bodyClassName={styles.body}
    >
      <div className={styles.iconWrapper}>
        {ACTIVITY_TYPES[`${type}`]?.icon}
      </div>
      <div className={styles.textContainer}>
        <div className={styles.title}>
          {title || ACTIVITY_TYPES[`${type}`]?.title}
        </div>
        <p className={styles.description}>
          {description || ACTIVITY_TYPES[`${type}`]?.description}
        </p>
      </div>
    </AscGenericCard>
  );
}
